import config from "../../config.json";
const BASE_AUTH_API = config.BASE_AUTH_API;

export const addSaledItemsAPI = async (token, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}saled-items/add`, {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      // The route responds with { success, count, items }; `report` never
      // existed, so success used to be indistinguishable from failure.
      return responseData.items || responseData.report || true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const fetchSaledItemsAPI = async (token, sId) => {
  let responseData;
  try {
    const params = new URLSearchParams();
    sId.forEach((id) => params.append("sId", id));

    const url = `${BASE_AUTH_API}saled-items?${params.toString()}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const deleteSaledItemAPI = async (token, ids) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}saled-items`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ids}),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};